import UilCircularLoader from "@/components/circular-loader-uil";

const FullPageLoader = ({ message }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        flexDirection: "column",
        flex: 1,
        height: "calc(100dvh - 66px)",
      }}
    >
      <UilCircularLoader />
      <div>
        <div
          className="justify-content-center align-items-center"
          style={{
            textAlign: "center",
            visibility: "visible",
            display: "flex",
            height: "150px",
          }}
        >
          <p style={{ fontSize: "20px", color: "#000" }}>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default FullPageLoader;
